export default "__VITE_ASSET__6715b814__"